import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { EmailProviderRoutingService } from "./email-provider-routing.service";
import { EmailProviderRouting } from "./email-provider-routing.type";
import { SnackBarService } from "@teammood/shared/ui/snack-bar";

@Component({
    selector: "email-provider-routing",
    templateUrl: "./email-provider-routing.component.html",
    providers: [EmailProviderRoutingService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailProviderRoutingComponent implements OnInit {

    email_providers: EmailProviderRouting;

    constructor(private emailProviderRoutingService: EmailProviderRoutingService, private snackBarService: SnackBarService) {
    }

    async ngOnInit() {
        await this.loadData();
    }

    private async loadData(): Promise<void> {
        this.email_providers = await this.emailProviderRoutingService.get();
    }
   
    async updateProvider(email_providers: any): Promise<void> {
        this.email_providers = await this.emailProviderRoutingService.update(email_providers);
        this.snackBarService.success('Updated!')
    }
}